import { HomeMemberCenterLayout, HomeMemberProfile } from 'components';
import React from 'react';


/**
 * 在這邊描述這個組件
 */

export const HomeMemberProfilePage = () => {
  return (
    <HomeMemberCenterLayout>
      <HomeMemberProfile />
    </HomeMemberCenterLayout>
  );
};
